export default __webpack_public_path__ + "static/media/centro_andes_2_7.6bb83d34.JPG";